import { memo, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormCurrencyField from 'components/ui/form/FormCurrencyField';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(4, { label: 'validations.nameMin', value: 4 })
    .required('validations.name'),
  // valute: yup.number().required('validations.staff'),
  // phone: yup.string().required('validations.phone'),
});

const AddEditModal = ({ open, setOpen, setRefetch, itemData, setItemData }) => {
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      valute: '',
      sum: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (itemData?.id) {
        submit(
          { type: 'postUpdate', contentType: 'simple' },
          values,
          '/admin/supplier',
          values.name,
          itemData?.id,
          false,
          handleFinishRequest
        );
      } else
        submit(
          { type: 'post', contentType: 'simple' },
          values,
          '/admin/supplier',
          values.name,
          null,
          false,
          handleFinishRequest
        );
    },
  });

  useEffect(() => {
    if (itemData?.id) {
      formik.setValues({
        name: itemData?.name || '',
        valute: itemData?.valute || '',
        sum: itemData?.sum || '',
      });
    }
  }, [itemData]);

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemData('');
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-md',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-gray-100 !mb-2 !text-center'
      >
        {itemData?.id ? (
          <span>Yetkazib beruvchini tahrirlash</span>
        ) : (
          <span>Yetkazib beruvchini qo'shish</span>
        )}
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.1}
                label={'Nomi'}
                fieldName='name'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'Valyuta Summa'}
                fieldName='valute'
                formik={formik}
                disabled={!!itemData?.id}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormCurrencyField
                delay={0.1}
                label={'UZS Summa'}
                fieldName='sum'
                formik={formik}
                disabled={!!itemData?.id}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.6}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(AddEditModal);
